﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { PSMToken, ProductionStatusMonitoring, PSMDayToken, DailyToken, DailyTokenItem, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { ActivatedRoute,Params } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-prod-stat-mon',
  templateUrl: './prod-stat-mon.component.html',
  styleUrls: ['./prod-stat-mon.component.css']
})
export class ProdStatMonComponent implements OnInit {

  
  areChangesMade: boolean = false;

  editRow:PSMToken;
  currMonthDtObj:Date = new Date();
  prodStatusObj:ProductionStatusMonitoring;
  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editDate:Date = new Date();
  editParam1:any;
  editParam2:any;
  copyDataObj:ProductionStatusMonitoring;
  copySelDate:Date = new Date();
  isFullScrDaySel:boolean = true;
  selectedDayIndex:number = 0; 

  PSMDayTokenObj:PSMDayToken;
  CopyPSMDayTokenObj:Array<PSMToken>=[];
  selView:number = 1;  
  daywiseItemList: Array<DailyToken>;

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';
  mId:string = "ce48f02a-a091-4cb5-4759-a6b99b61eb9f";
  hasmodaccess:boolean = false;
  @ViewChild('childModal') public childModal:ModalDirective;
  @ViewChild('copyModal') public copyModal:ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(private _dataService:DataService,private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Monthly Production Status";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
    });
  }
  
  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }
  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":        
        this.editRow = _param1.cloneSelf();
        this.editType = _editToken;
        this.editHeader = "Edit Production Status (" + this.formatHeaderDate(this.PSMDayTokenObj.selDate) +")";
      break;
      case "newrow":
      this.editRow = new PSMToken(null,null,null,null,null,null,null,null,null,(new Date()).getTime())
      this.editType = _editToken;
      this.editHeader = "Add Production Status (" + this.formatHeaderDate(this.PSMDayTokenObj.selDate) +")";
      break;
      case "date":
        this.editDate = this.prodStatusObj.monthDate;
        this.editType = 'date';
        this.editHeader = "Edit Date";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }
  getData(option){
    if(option) return option
    return '-'
  }
  public addNewProdRow(_newRowToken:string,_dayIndex:number){
    switch(_newRowToken){
      case "newrow":
      this.showChildModal(_newRowToken,null,null);
        this.editType = 'newrow';
      break;
    }
  }
  
  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadProdStatusMontring(this.currMonthDtObj).subscribe((_Prod:ProductionStatusMonitoring) => {
        if(_Prod!=null){
          this.prodStatusObj = _Prod;
          this.loadDateData();          
          let _tmpDailyTokenList: Array<DailyToken> = [];
          for (var i = 0; i < this.prodStatusObj.dayTokens.length; i++) {
            let _tmpDate:Date = this.prodStatusObj.dayTokens[i].selDate;
            let _tmpDailyTokens:Array<DailyTokenItem> = [];            
            let _indexer:number = 0;
            this.prodStatusObj.dayTokens[i].dateTokens.forEach((_tmpObj:PSMToken) => {
              _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.productId,0), this.getIdObj(_tmpDate,_indexer),''));
              _indexer++;
            });
            _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
          }
  
          this.daywiseItemList = _tmpDailyTokenList;
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
        }
        else{
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }
  private getDisplayTokenName(_custId:string,_quantity:number){
    return this._dataService.getProductName(_custId) ;
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
 
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
      this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
      
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();      
      this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
    }
  }

  prevCopyDateSel():void{
      this.copySelDate.setDate(this.copySelDate.getDate()-1);
      this.copyData();
  }
  nextCopyDateSel():void{
      this.copySelDate.setDate(this.copySelDate.getDate()+1);
      this.copyData();
  }

  getProductName(_prodId: string): string {
    if (_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  
  validateData():boolean{
    return true;
  }
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }
  saveData(_sendMail: boolean):void{
    if(this.validateData()==true){
      this._dataService.saveProdStatusMonitoring(this.prodStatusObj, _sendMail)
      .subscribe((resp:GenResponse) => {
        if(resp.status == DataService.statusFail){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
        }

      });
    }
  }
  
  
  removeActionDecided(_newRowToken:string,_dayIndex:number,_rowIndex:number){
    switch(_newRowToken){
      case "rowedit":
       // this.datatables.dayTokens[_dayIndex].splice(_rowIndex,1);
      break;
    }
  }

  discardData(): void {
    this.loadMonthData();
  }
  copyData(){
    this.copyDataObj=null;
    this._dataService.getCopyData(this.copySelDate).subscribe((_doc:ProductionStatusMonitoring) => {
      if(_doc.dayTokens.length>0){  
        this.copyDataObj = _doc;
        this.loadCopyDateData();
      }
      else{
        this.CopyPSMDayTokenObj = [];
      }
    });
    this.copyModal.show();
  }
  hideCopyChildModal(){
    this.copyModal.hide()
  }
  discardCopyData(){    
    this.CopyPSMDayTokenObj=[];
    this.hideCopyChildModal()
  }
  openCopyModal(){ 
    this.copySelDate = new Date(this.currMonthDtObj.getTime()) 
    this.copySelDate.setDate(this.copySelDate.getDate() - 1)
    this.copyData();
  }
 
 
  public prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
   // this.copySelDate = this.currMonthDtObj;
    this.loadMonthData();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
   // this.copySelDate = this.currMonthDtObj;
    this.loadMonthData();
  }
  
  loadDateData():void{
    let _tmpDPHDayToken:PSMDayToken = this.prodStatusObj.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.prodStatusObj.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.prodStatusObj.getDateToken(this.currMonthDtObj);
    }
    this.PSMDayTokenObj = _tmpDPHDayToken;
  }
  loadCopyDateData():void{
    this.CopyPSMDayTokenObj = [];
    if(this.copyDataObj.dayTokens[0]){
      for(var i=0;i<this.copyDataObj.dayTokens[0].dateTokens.length;i++){
        let temp = this.copyDataObj.dayTokens[0].dateTokens[i];
        this.CopyPSMDayTokenObj.push(new PSMToken(temp.productId,temp.scheduleMnth,temp.tillDatePrdction,temp.balanceQty,temp.ystrdyProductin,temp.tdayProdctonPlan,temp.dateTestedQty,temp.dateGreenSticker,temp.balanceGreenStickerQty,temp.creationDate))
      }
    }
  }
  formatMonth(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "MMM-YYYY");
    }
    return '-';
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-MM-YYYY");
    }
    return '-';
  }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  formatCopyHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }


  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
  dataEdited(){
    switch(this.editToken){
      case "rowedit":      
          this.editParam1.productName = this.editRow.productId;
          this.editParam1.scheduleMnth = this.editRow.scheduleMnth;
          this.editParam1.tillDatePrdction = this.editRow.tillDatePrdction;
          this.editParam1.balanceQty = this.editRow.balanceQty;
          this.editParam1.ystrdyProductin = this.editRow.ystrdyProductin;
          this.editParam1.tdayProdctonPlan = this.editRow.tdayProdctonPlan;
          this.editParam1.dateTestedQty = this.editRow.dateTestedQty;
          this.editParam1.dateGreenSticker = this.editRow.dateGreenSticker;
          this.editParam1.creationDate = this.editRow.creationDate
      break;
      case "newrow":
        this.prodStatusObj.addDateToken(new Date(this.currMonthDtObj),new PSMToken(this.editRow.productId,this.editRow.scheduleMnth,this.editRow.tillDatePrdction,this.editRow.balanceQty,this.editRow.ystrdyProductin,this.editRow.tdayProdctonPlan,this.editRow.dateTestedQty,this.editRow.dateGreenSticker,this.editRow.balanceGreenStickerQty,this.editRow.creationDate));
      break;
      case "date":
        this.prodStatusObj.monthDate = this.editDate;
        this.currMonthDtObj = this.editDate;
      break
    }
    this.areChangesMade = true;
    this.hideChildModal();
  }
  public hideChildModal():void {
    this.childModal.hide();
  }

  public discardSaveData():void {
      this.childModal.hide();
  }
  removeRecord(_tokenIndex:number){
    this.PSMDayTokenObj.removeToken(_tokenIndex);
    this.areChangesMade = true;
}

  getScreenModeClass(_dayIndex:number){
    if(this.isFullScrDaySel == true && _dayIndex == this.selectedDayIndex){
      return 'fa-minus-square'
    }
    return 'fa-plus-square';
  }
  changeScreenMode(_dayIndex:number){
    if(this.isFullScrDaySel == true){
      this.isFullScrDaySel = false;
    }
    else{
      this.isFullScrDaySel = true;
      this.selectedDayIndex = _dayIndex;
    }
  }
  dataCopied(){
    for(var i=0;i<this.CopyPSMDayTokenObj.length;i++){
      this.CopyPSMDayTokenObj[i].creationDate = (new Date()).getTime();
      this.PSMDayTokenObj.addToken(this.CopyPSMDayTokenObj[i])
    } 
    this.areChangesMade = true;
    this.discardCopyData(); 
      
  }
  isInProductType(_productId:string, _productTypeId:string){
    for(var i=0;i<this._dataService.products.length;i++){
      if(this._dataService.products[i].productId == _productId){
        if(this._dataService.products[i].productType == _productTypeId) 
            return true;
        else 
           return false;
      }
    }
  }null
  calculate(name:string,dayTokens:Array<PSMToken>,_productTypeId:string = null){ 
    let array:Array<PSMToken>;
    if(_productTypeId){
      array = dayTokens.filter((_obj:PSMToken) => {
        return  this.isInProductType(_obj.productId,_productTypeId);
      });
    }
    else{
      array = dayTokens;
    }
    
    switch(name){
      case 'scheduleMnth':
        var sdmtkn = 0
        for(var i=0;i<array.length;i++){
          if(array[i].scheduleMnth){
              sdmtkn += Number(array[i].scheduleMnth);
          }
        }
        return sdmtkn;
      
      case 'tillDatePrdction':
        var tdptkn = 0
        for(var i=0;i<array.length;i++){
          if(array[i].tillDatePrdction){
            tdptkn=  tdptkn+Number(array[i].tillDatePrdction)
          }
        }
        return tdptkn;
      
      case 'balanceQty':
        var bqtkn = 0
        for(var i=0;i<array.length;i++){
          if(array[i].balanceQty){
            bqtkn=  bqtkn+Number(array[i].balanceQty)
          }
        }
        return bqtkn;
      
      case 'ystrdyProductin':
        var ydptkn = 0
        for(var i=0;i<array.length;i++){
          if(array[i].ystrdyProductin){
            ydptkn=  ydptkn+Number(array[i].ystrdyProductin)
          }
        }
        return ydptkn;
      
      case 'tdayProdctonPlan':
        var tdpptkn = 0
        for(var i=0;i<array.length;i++){
          if(array[i].tdayProdctonPlan){
            tdpptkn=  tdpptkn+Number(array[i].tdayProdctonPlan)
          }
        }
        return tdpptkn;
      
      case 'dateTestedQty':
        var dtqtkn = 0
        for(var i=0;i<array.length;i++){
          if(array[i].dateTestedQty){
            dtqtkn=  dtqtkn+Number(array[i].dateTestedQty)
          }
        }
        return dtqtkn;
      
      case 'dateGreenSticker':
      var tgstkn = 0
      for(var i=0;i<array.length;i++){
        if(array[i].dateGreenSticker){
          tgstkn=  tgstkn+Number(array[i].dateGreenSticker)
        }
      }
      return tgstkn;   
      
      case 'balanceGreenStickerQty':
        var bgstkn = 0
        for(var i=0;i<array.length;i++){
          if(array[i].balanceGreenStickerQty){
            bgstkn=  bgstkn+Number(array[i].balanceGreenStickerQty)
          }
        }
        return bgstkn;
    }
  }

// calculateQty(sm,tp){
//   var val = 0
//   if(sm){
//     if(tp){
//       val = Number(tp) - Number(sm)
//       this.editRow.balanceQty = val+""
//     }
//     else{
//       tp = 0
//       val = Number(tp) - Number(sm)
//       this.editRow.balanceQty = val+""
//     }      
//   }
//   else{
//     sm = 0
//     val = Number(tp) - Number(sm)
//     this.editRow.balanceQty = val+""
//   } 
  
// }
//   calculateBalanceQty(sm,tp){
//     var val = 0
//     if(sm){
//       if(tp){
//         val = Number(sm) - Number(tp)
//         this.editRow.balanceGreenStickerQty = val+""
//       }
//       else{
//         tp = 0
//         val = Number(sm) - Number(tp)
//         this.editRow.balanceGreenStickerQty = val+""
//       }      
//     }
//     else{
//       sm = 0
//       val = Number(sm) - Number(tp)
//       this.editRow.balanceGreenStickerQty = val+""
//     } 
//   }

  getDayColClass(_dayIndex:number){
    if(this.isFullScrDaySel == true){
      if(this.selectedDayIndex == _dayIndex)
        return "col-lg-12";
      else
        return "hide";
    }
    else{
      return "col-lg-4";
    }
  }


}
